import {
  getShiftHours,
} from "./shiftLifecycle";

import {
  getShiftBillRate,
} from "../../utils/invoiceEngine";

import {
  getShiftPayRate,
} from "../../utils/payrollEngine";

function roundMoney(value) {
  const number = Number(value || 0);

  if (!Number.isFinite(number)) {
    return 0;
  }

  return (
    Math.round(number * 100) /
    100
  );
}

export function getShiftFinancialSnapshot(
  shift
) {
  const hours =
    getShiftHours(shift);

  const payRate =
    getShiftPayRate(shift);

  const billRate =
    getShiftBillRate(shift);

  const payroll =
    roundMoney(
      hours * payRate
    );

  const invoice =
    roundMoney(
      hours * billRate
    );

  const margin =
    roundMoney(
      invoice - payroll
    );

  const marginPercent =
    invoice > 0
      ? Math.round(
          (margin / invoice) *
            10000
        ) / 100
      : 0;

  return {
    hours,
    payRate,
    billRate,
    payroll,
    invoice,
    margin,
    marginPercent,
  };
}